
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1625',
  depVersions: {
  "customer-portal-app": "static-1.1625",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "data-fetching-client": "static-1.9446",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24636",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5360",
  "hs-test-utils": "static-1.7774",
  "hub-http": "static-1.5966",
  "hub-http-shared-msw-handlers": "static-1.9402",
  "hubspot-dlb": "static-2.1796",
  "hubspot-prosemirror": "static-1.17515",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11188",
  "I18n": "static-7.1561",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6241",
  "payment-link-components": "static-1.22851",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6684",
  "quartz-core": "static-1.5903",
  "react": "static-7.177",
  "react-colorpicker": "static-2.9981",
  "react-dlb": "static-1.71",
  "react-utils": "static-2.5145",
  "rich-text-lib": "static-1.19420",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17603",
  "ui-components-test-utils": "static-1.5326",
  "UIComponents": "static-3.8135",
  "foundations-assets": "static-1.4601",
  "foundations-components": "static-1.7463",
  "foundations-theming": "static-1.4177",
  "foundations-theming-specialty": "static-1.1893",
  "framer-motion": "static-1.67",
  "history": "static-4.47",
  "metrics-js": "static-1.9391",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.500",
  "quartz-config": "static-1.462",
  "quartz-routing": "static-1.114",
  "quick-fetch": "static-1.3704",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16409",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7909",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.50",
  "ui-addon-draggable": "static-3.4534",
  "ui-addon-react-router-dom": "static-1.9317",
  "usage-tracker": "static-1.7102",
  "usage-tracker-anonymous": "static-1.5519",
  "usage-tracker-core": "static-1.6952",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3199",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2961",
  "quartz-webpack": "static-1.2908",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.77",
  "customer-data-objects": "static-1.7413",
  "frontend-preferences-client": "static-1.7692",
  "laboratory-lib": "static-3.6931",
  "onboarding-scopes": "static-1.6233",
  "rpc-client-utils": "static-1.4401",
  "ui-addon-opt": "static-4.8154",
  "HeadJS": "static-2.703",
  "hs-test-utils-bend-plugin": "static-1.2885",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "ts-schema": "static-1.3875",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7402",
  "cssUtils": "static-1.723",
  "customer-data-ui-utilities": "static-1.9593",
  "HubStyle": "static-2.11496",
  "knowledge-content-types": "static-1.8338",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.359",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.483",
  "ui-addon-emoji-picker": "static-1.9658",
  "ui-addon-i18n": "static-1.10900",
  "ui-business-units-lib": "static-1.8792",
  "ui-shepherd-react": "static-3.9914",
  "video-components-external": "static-1.10481",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4099",
  "commerce-tours-lib": "static-1.5671",
  "customer-data-properties": "static-1.50697",
  "getting-started-shared-tasks": "static-1.17792",
  "growth-onboarding-reliability": "static-1.4857",
  "onboarding-tours": "static-1.16215",
  "reference-resolvers-lite": "static-1.7858",
  "sales-checkout-service-client": "static-1.3447",
  "ui-addon-iframeable": "static-1.8810",
  "user-context": "static-1.4863",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.786",
  "hubspotter-http": "static-1.4449",
  "icons": "static-2.618",
  "mobile-manifest-mixins": "static-1.476",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.359",
  "quartz-head": "static-1.349",
  "quartz-test": "static-1.359",
  "ui-fonts": "static-1.450",
  "usage-tracker-container": "static-1.7092",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9197",
  "data-token-picker": "static-1.15992",
  "FileManagerLib": "static-1.38436",
  "property-translator": "static-1.5182",
  "atom": "static-1.4839",
  "merchandise-lib": "static-1.257",
  "purchase-motions-components": "static-1.5439",
  "salesImages": "static-1.520",
  "self-service-api": "static-1.10005",
  "SharedI18nStrings": "static-1.180",
  "upgrade-management-service-types": "static-1.4277",
  "foundations-components-test-utils": "static-1.4946",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.94",
  "ui-images": "static-2.1083",
  "bend-plugin-foundations-components": "static-1.3732",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "trellis-assets": "static-1.1107",
  "bend-plugin-foundations-theming": "static-1.2660",
  "foundations-theming-base": "static-1.3162",
  "stylex": "static-1.27",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4243",
  "react-flip-move": "static-1.65",
  "bender-build-tools": "static-1.2903",
  "inbound-db-properties-service-client": "static-1.3647",
  "superstore": "static-1.4540",
  "feedback-loader": "static-1.28795",
  "ai-components-ui-library": "static-1.8265",
  "ui-addon-video-player": "static-1.8465",
  "ui-coaching-tips": "static-1.27861",
  "sassPrefix": "static-1.151",
  "react-dnd-compat": "static-1.4392",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2254",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7928",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4418",
  "content-media-composition-data-lib": "static-1.11338",
  "content-media-compositions": "static-2.15345",
  "idb-keyval": "static-1.39",
  "immer": "static-1.33",
  "immerable": "static-1.3923",
  "magpie-lib": "static-1.5363",
  "magpie-types": "static-1.4823",
  "media-bridge-lib": "static-1.18514",
  "video-data-lib": "static-1.34139",
  "commerce-products-lib": "static-1.8761",
  "crm-message-bus": "static-1.42256",
  "growth-data-modal": "static-1.5119",
  "hubspot-apollo-client": "static-1.4648",
  "onboarding-tours-client": "static-1.4429",
  "calling-global-api": "static-1.63548",
  "calling-internal-common": "static-1.31061",
  "calling-lifecycle-internal": "static-1.64930",
  "calling-lifecycle-messages": "static-1.57224",
  "conditional-properties-service-client": "static-1.3595",
  "crm-links": "static-1.6023",
  "customer-data-objects-ui-components": "static-1.12772",
  "customer-data-property-utils": "static-1.7840",
  "external-options-client-types": "static-1.3955",
  "file-manager-components": "static-1.22796",
  "framework-data-schema-resolvers": "static-1.6638",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.442",
  "inbound-db-meta-service-client": "static-1.3397",
  "inbounddb-objects-service-types": "static-1.4021",
  "meetings-icalendar-utils-lib": "static-1.403",
  "multi-currency-client-types": "static-1.3489",
  "object-builder-ui-client": "static-1.47867",
  "pipeline-validation-client-types": "static-1.3758",
  "property-value-citations": "static-1.1311",
  "pulse": "static-1.273",
  "smart-property-lib": "static-1.5762",
  "tiered-pricing": "static-1.782",
  "ui-addon-form-validation": "static-1.10763",
  "growth-onboarding-confetti": "static-1.2839",
  "growth-onboarding-next-action-utils": "static-1.1264",
  "navigation-components": "static-1.17167",
  "onboarding-tours-utils": "static-1.281",
  "ui-shepherd-tracker": "static-1.7295",
  "ui-universal-auth": "static-1.8648",
  "batch-promise": "static-1.1319",
  "navigation-messaging": "static-1.6494",
  "getting-started-shared-tasks-store": "static-1.16910",
  "hubspotter-http-shared-msw-handlers": "static-1.9400",
  "audio-components": "static-1.5567",
  "FileManagerCore": "static-1.38295",
  "FileManagerImages": "static-1.35947",
  "video-components": "static-1.12484",
  "growth-monetization-service-types": "static-1.4293",
  "nav-client-types": "static-1.2125",
  "purchase-motions-api": "static-1.5442",
  "signup-constants": "static-1.18328",
  "signup-ui-url-generator": "static-2.7833",
  "trials-service-types": "static-1.3694",
  "chatspot-core": "static-1.20189",
  "chirp-fetch": "static-1.1652",
  "ContentUtils": "static-1.67529",
  "copilot-toolkit": "static-1.10445",
  "growth-onboarding-feedback-components": "static-1.6354",
  "hls.js": "static-1.34",
  "reactive-lib": "static-1.495",
  "simple-logging-lib": "static-1.2819",
  "customer-data-tracking": "static-1.6651",
  "products-iframe-lib": "static-1.7230",
  "products-ui-components-shared-msw-handlers": "static-1.9784",
  "hubspot-apollo-cache": "static-1.107",
  "calling-error-reporting": "static-1.31067",
  "shared-worker-versioning": "static-1.10806",
  "calling-usage-tracker": "static-1.6307",
  "voice-sms-access-library": "static-1.151",
  "conversations-skeleton-state": "static-1.7018",
  "location-customization-utils-lib": "static-1.8457",
  "crm-pipelines-api-client-types": "static-1.3936",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6543",
  "persist-promise": "static-1.3476",
  "directed-graph": "static-1.706",
  "event-emitter": "static-1.716",
  "breeze-intelligence-kit": "static-1.5275",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9485",
  "fsm": "static-1.3500",
  "policy-lib": "static-1.6553",
  "react-tinymce": "static-1.54536",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9548",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53662",
  "tinymce-plugins": "static-1.56776",
  "tinymce-themes": "static-1.55632",
  "unified-auth-core-lib": "static-1.443",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4303",
  "video-embed": "static-1.34973",
  "content-icons-ui": "static-1.2144",
  "social-insights-client-types": "static-1.21265",
  "eligibility-engine-service-types": "static-1.2975",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4575",
  "integrations-lib": "static-1.15315",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4061",
  "calling-orchestration-schema": "static-1.34928",
  "crm-record-cards-service-types": "static-1.3423",
  "highcharts": "static-8.99",
  "trellis-story-utils": "static-1.4292",
  "storybook-react": "static-1.28",
  "hub-http-contrib": "static-1.2813",
  "interframe": "static-3.4560",
  "tinymce-data": "static-1.39747",
  "ui-addon-sales-email": "static-1.4982",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11976",
  "layout-dnd-utils": "static-1.10951",
  "react-codemirror": "static-1.10395",
  "ui-brand-identity-lib": "static-1.13722",
  "NamespacedHubStyle": "static-2.8868",
  "outpost": "static-1.3975",
  "flux-actions": "static-1.304",
  "integrations-error-boundary-lib": "static-1.12730",
  "integrations-tracking-lib": "static-1.5353",
  "native-integrations-shared-strings": "static-1.7557",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10141",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67604",
  "layout-data-lib": "static-1.9276",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2764",
  "advanced-menus-core": "static-1.14770",
  "advanced-menus-lib": "static-1.11752",
  "ExportDialog": "static-6.10157",
  "ui-memberships-settings-lib": "static-1.33345",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14769",
  "simple-menus-lib": "static-1.16286"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1625",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "data-fetching-client": "/data-fetching-client/static-1.9446",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24636",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5360",
  "hs-test-utils": "/hs-test-utils/static-1.7774",
  "hub-http": "/hub-http/static-1.5966",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9402",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17515",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11188",
  "I18n": "/I18n/static-7.1561",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6241",
  "payment-link-components": "/payment-link-components/static-1.22851",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6684",
  "quartz-core": "/quartz-core/static-1.5903",
  "react": "/react/static-7.177",
  "react-colorpicker": "/react-colorpicker/static-2.9981",
  "react-dlb": "/react-dlb/static-1.71",
  "react-utils": "/react-utils/static-2.5145",
  "rich-text-lib": "/rich-text-lib/static-1.19420",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17603",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5326",
  "UIComponents": "/UIComponents/static-3.8135",
  "foundations-assets": "/foundations-assets/static-1.4601",
  "foundations-components": "/foundations-components/static-1.7463",
  "foundations-theming": "/foundations-theming/static-1.4177",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1893",
  "framer-motion": "/framer-motion/static-1.67",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9391",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.500",
  "quartz-config": "/quartz-config/static-1.462",
  "quartz-routing": "/quartz-routing/static-1.114",
  "quick-fetch": "/quick-fetch/static-1.3704",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16409",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7909",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.50",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4534",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9317",
  "usage-tracker": "/usage-tracker/static-1.7102",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5519",
  "usage-tracker-core": "/usage-tracker-core/static-1.6952",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3199",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2961",
  "quartz-webpack": "/quartz-webpack/static-1.2908",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.77",
  "customer-data-objects": "/customer-data-objects/static-1.7413",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7692",
  "laboratory-lib": "/laboratory-lib/static-3.6931",
  "onboarding-scopes": "/onboarding-scopes/static-1.6233",
  "rpc-client-utils": "/rpc-client-utils/static-1.4401",
  "ui-addon-opt": "/ui-addon-opt/static-4.8154",
  "HeadJS": "/HeadJS/static-2.703",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2885",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "ts-schema": "/ts-schema/static-1.3875",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7402",
  "cssUtils": "/cssUtils/static-1.723",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9593",
  "HubStyle": "/HubStyle/static-2.11496",
  "knowledge-content-types": "/knowledge-content-types/static-1.8338",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.359",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9658",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10900",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8792",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9914",
  "video-components-external": "/video-components-external/static-1.10481",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4099",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5671",
  "customer-data-properties": "/customer-data-properties/static-1.50697",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17792",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4857",
  "onboarding-tours": "/onboarding-tours/static-1.16215",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7858",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3447",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8810",
  "user-context": "/user-context/static-1.4863",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.786",
  "hubspotter-http": "/hubspotter-http/static-1.4449",
  "icons": "/icons/static-2.618",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.359",
  "quartz-head": "/quartz-head/static-1.349",
  "quartz-test": "/quartz-test/static-1.359",
  "ui-fonts": "/ui-fonts/static-1.450",
  "usage-tracker-container": "/usage-tracker-container/static-1.7092",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9197",
  "data-token-picker": "/data-token-picker/static-1.15992",
  "FileManagerLib": "/FileManagerLib/static-1.38436",
  "property-translator": "/property-translator/static-1.5182",
  "atom": "/atom/static-1.4839",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "purchase-motions-components": "/purchase-motions-components/static-1.5439",
  "salesImages": "/salesImages/static-1.520",
  "self-service-api": "/self-service-api/static-1.10005",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4277",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4946",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.94",
  "ui-images": "/ui-images/static-2.1083",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3732",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.1107",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2660",
  "foundations-theming-base": "/foundations-theming-base/static-1.3162",
  "stylex": "/stylex/static-1.27",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4243",
  "react-flip-move": "/react-flip-move/static-1.65",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3647",
  "superstore": "/superstore/static-1.4540",
  "feedback-loader": "/feedback-loader/static-1.28795",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8265",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8465",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27861",
  "sassPrefix": "/sassPrefix/static-1.151",
  "react-dnd-compat": "/react-dnd-compat/static-1.4392",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2254",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7928",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4418",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11338",
  "content-media-compositions": "/content-media-compositions/static-2.15345",
  "idb-keyval": "/idb-keyval/static-1.39",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3923",
  "magpie-lib": "/magpie-lib/static-1.5363",
  "magpie-types": "/magpie-types/static-1.4823",
  "media-bridge-lib": "/media-bridge-lib/static-1.18514",
  "video-data-lib": "/video-data-lib/static-1.34139",
  "commerce-products-lib": "/commerce-products-lib/static-1.8761",
  "crm-message-bus": "/crm-message-bus/static-1.42256",
  "growth-data-modal": "/growth-data-modal/static-1.5119",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4648",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4429",
  "calling-global-api": "/calling-global-api/static-1.63548",
  "calling-internal-common": "/calling-internal-common/static-1.31061",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64930",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57224",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3595",
  "crm-links": "/crm-links/static-1.6023",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12772",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7840",
  "external-options-client-types": "/external-options-client-types/static-1.3955",
  "file-manager-components": "/file-manager-components/static-1.22796",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6638",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.442",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4021",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.403",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3489",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47867",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3758",
  "property-value-citations": "/property-value-citations/static-1.1311",
  "pulse": "/pulse/static-1.273",
  "smart-property-lib": "/smart-property-lib/static-1.5762",
  "tiered-pricing": "/tiered-pricing/static-1.782",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10763",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2839",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1264",
  "navigation-components": "/navigation-components/static-1.17167",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.281",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7295",
  "ui-universal-auth": "/ui-universal-auth/static-1.8648",
  "batch-promise": "/batch-promise/static-1.1319",
  "navigation-messaging": "/navigation-messaging/static-1.6494",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16910",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9400",
  "audio-components": "/audio-components/static-1.5567",
  "FileManagerCore": "/FileManagerCore/static-1.38295",
  "FileManagerImages": "/FileManagerImages/static-1.35947",
  "video-components": "/video-components/static-1.12484",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4293",
  "nav-client-types": "/nav-client-types/static-1.2125",
  "purchase-motions-api": "/purchase-motions-api/static-1.5442",
  "signup-constants": "/signup-constants/static-1.18328",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7833",
  "trials-service-types": "/trials-service-types/static-1.3694",
  "chatspot-core": "/chatspot-core/static-1.20189",
  "chirp-fetch": "/chirp-fetch/static-1.1652",
  "ContentUtils": "/ContentUtils/static-1.67529",
  "copilot-toolkit": "/copilot-toolkit/static-1.10445",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6354",
  "hls.js": "/hls.js/static-1.34",
  "reactive-lib": "/reactive-lib/static-1.495",
  "simple-logging-lib": "/simple-logging-lib/static-1.2819",
  "customer-data-tracking": "/customer-data-tracking/static-1.6651",
  "products-iframe-lib": "/products-iframe-lib/static-1.7230",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9784",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.107",
  "calling-error-reporting": "/calling-error-reporting/static-1.31067",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10806",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6307",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7018",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8457",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3936",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6543",
  "persist-promise": "/persist-promise/static-1.3476",
  "directed-graph": "/directed-graph/static-1.706",
  "event-emitter": "/event-emitter/static-1.716",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5275",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9485",
  "fsm": "/fsm/static-1.3500",
  "policy-lib": "/policy-lib/static-1.6553",
  "react-tinymce": "/react-tinymce/static-1.54536",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9548",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53662",
  "tinymce-plugins": "/tinymce-plugins/static-1.56776",
  "tinymce-themes": "/tinymce-themes/static-1.55632",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.443",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4303",
  "video-embed": "/video-embed/static-1.34973",
  "content-icons-ui": "/content-icons-ui/static-1.2144",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2975",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4575",
  "integrations-lib": "/integrations-lib/static-1.15315",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4061",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34928",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3423",
  "highcharts": "/highcharts/static-8.99",
  "trellis-story-utils": "/trellis-story-utils/static-1.4292",
  "storybook-react": "/storybook-react/static-1.28",
  "hub-http-contrib": "/hub-http-contrib/static-1.2813",
  "interframe": "/interframe/static-3.4560",
  "tinymce-data": "/tinymce-data/static-1.39747",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4982",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11976",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10951",
  "react-codemirror": "/react-codemirror/static-1.10395",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13722",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8868",
  "outpost": "/outpost/static-1.3975",
  "flux-actions": "/flux-actions/static-1.304",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12730",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5353",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7557",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10141",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67604",
  "layout-data-lib": "/layout-data-lib/static-1.9276",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2764",
  "advanced-menus-core": "/advanced-menus-core/static-1.14770",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11752",
  "ExportDialog": "/ExportDialog/static-6.10157",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33345",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14769",
  "simple-menus-lib": "/simple-menus-lib/static-1.16286"
}
};
